import React from "react";
import {useDispatch} from "react-redux";
import {Avatar, Popover} from "antd";
import {userSignOut} from "appRedux/actions/Auth";

const UserInfo = () => {

  const dispatch = useDispatch();

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li>My Account</li>
      <li>Connections</li>
      <li>
        <button type="button" onClick={() => dispatch(userSignOut())}
            style={{
              background: 'none', border: 'none', margin: 0, padding: 0,
              font: 'inherit', color: 'inherit', textAlign: 'inherit', cursor: 'pointer',
              width: '100%', display: 'block',
            }}>Logout
        </button>
      </li>
    </ul>
  );

  return (
    <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={userMenuOptions} trigger="click">
      <Avatar src={"https://via.placeholder.com/150"} className="gx-avatar gx-pointer" alt=""/>
    </Popover>
  );
};

export default UserInfo;
